import useSWR, { SWRResponse } from "swr";

import { useAuthErrorHandler } from "../common/hooks";
import { Director } from "../types/common";
import { UserCurrent,Party } from "../types/userCurrent";

import request, { AccessTokenHeader, ApiError } from "./common";
import { ProjectUserRole } from "../types/project";

const userCurrentApi = {
    getCurrentUser: (): Promise<UserCurrent> => {
        return request<UserCurrent>("/user/current", "GET");
    },
    getCurrentUserWithToken: (token: string): Promise<UserCurrent> => {
        return request<UserCurrent>(
            "/token-access/user/current",
            "GET",
            undefined,
            {
                headers: {
                    [AccessTokenHeader]: token,
                },
            },
        );
    },
};

export const userCurrentPartyApi = {
    getCurrentUserParty: (): Promise<Party> => {
        return request<Party>("/user/current/party", "GET");
    },
    getCurrentUserPartyWithToken: (token: string): Promise<Party> => {
        return request<Party>(
            "/token-access/user/current/party",
            "GET",
            undefined,
            {
                headers: {
                    [AccessTokenHeader]: token,
                },
            },
        );
    },
};

export const useDirectorList = (): SWRResponse<Director[], ApiError> => {
    const onError = useAuthErrorHandler();
    return useSWR<Director[], ApiError>(
        `/users/role/${ProjectUserRole.PAYMENT_ORDER_APPROVER}`,
        request,
        {
            onError,
        },
    );
};

export default userCurrentApi;
